import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import classNames from 'classnames/bind';
import Dialog from '../../../../../molecules/Dialog';
import Text from '../../../../../atoms/Text';
import Icon from '../../../../../atoms/Icon';
import ActionButton from '../../common/ActionButton';
import ModalContent from '../../common/ModalContent';
import GrandPrizeHeader from '../TopShopperHeader/GrandPrizeHeader';
import LeaderBoard from '../LeaderBoard';
import * as GrandSelector from './GrandSelector';
import * as GrandConstant from './GrandPrizeConstant';
import styles from './index.pcss';
import getCurrentUser from '../../../utils/userDetails';
import {
  getTopShopperTermsHyperlink,
  getTopShopperShopMoreHyperlink,
  getTopHeaderPrize,
  getLuckyDrawText,
  getLuckyChampList,
  getTopShopperHowToWinList
} from '../../../../../selectors/featureFlagsSelector';
import { SHOP_MORE_URL } from '../../../Constants';

const mapStateToProps = (
  state: import('../../../../../types/rootState').RootState
): import('../../../types/topshopper-page-types').TopShopperGameGrandState => {
  return {
    pageHeader: GrandSelector.getPageHeader(state),
    leaderBoardUser: GrandSelector.getLeaderBoardUser(state),
    modalGoldData: GrandSelector.getModalGoldData(state),
    saleType: GrandSelector.getSaleType(state),
    image: GrandSelector.getImage(state),
    topShopperTermsHyperlink: getTopShopperTermsHyperlink(state),
    shopMoreHyperlink: getTopShopperShopMoreHyperlink(state),
    topHeaderPrize: getTopHeaderPrize(state),
    luckyDrawText: getLuckyDrawText(state),
    luckyChampList: getLuckyChampList(state),
    topShopperHowToWinList: getTopShopperHowToWinList(state)
  };
};

const mapDispatchToProps = {
  data: '',
  user: ''
};
const connector = connect(mapStateToProps, mapDispatchToProps);
type GrandPrizeProps = ConnectedProps<typeof connector>;

const cx = classNames.bind(styles);
interface LoginUserType {
  platform: string;
  name?: string | null;
  mobile?: string | null;
  uuid?: string | null;
}
function GrandPrize(props: GrandPrizeProps): JSX.Element {
  const {
    pageHeader: { header, description } = {},
    leaderBoardUser = [],
    modalGoldData = [],
    saleType = '',
    image = '',
    platform = '',
    onGoBack,
    topShopperTermsHyperlink,
    redirectPage,
    shopMoreHyperlink,
    topHeaderPrize,
    luckyDrawText,
    luckyChampList,
    topShopperHowToWinList
  } = props;

  const shopMoreUrl = shopMoreHyperlink || SHOP_MORE_URL;
  const currentUser = getCurrentUser();
  const [visibility, setVisibility] = React.useState(false);
  const showDialog = (): void => {
    setVisibility(true);
  };
  const hideDialog = (): void => {
    setVisibility(false);
  };
  const renderGrandPrizeHeader = (): JSX.Element => (
    <div className={cx('grand-header')}>
      <Text weight="bold" variant="T4">
        {luckyChampList}
      </Text>
    </div>
  );

  const renderFooterText = (): JSX.Element => {
    return (
      <div className={cx('info-alert')}>
        <Icon icon="icon-Info" iconClass={cx('add-spacing')} />
        <Text variant="T2" color="Nero" weight="regular">
          {saleType === 'PRE_SALE' || saleType === 'ACTIVE_SALE'
            ? GrandConstant.GRAND_PAGE_HEADER.preText
            : GrandConstant.GRAND_PAGE_HEADER.postText}
        </Text>
      </div>
    );
  };

  return (
    <div className={cx('grand-prize-container')}>
      <GrandPrizeHeader
        platform={platform}
        header={header}
        description={description}
        middleImg={image}
        onClick={onGoBack}
        topHeaderPrize={topHeaderPrize}
        luckyDrawText={luckyDrawText}
      />
      <div className={cx('grand-prize-rank-section')}>
        <ActionButton
          btnLabel="How to win Grand Prize?"
          variant="big"
          textClass={cx('text-font')}
          fullWidth
          icon={platform === 'msite' ? 'icon-Chevron-Down' : 'icon-Chevron-Right'}
          onClick={showDialog}
          iconClass={cx('icon-font')}
        />
        <div className={cx('grand-prize-LeaderBoard')}>
          <LeaderBoard
            list={leaderBoardUser}
            currentUser={currentUser}
            type="grand"
            renderGrandPrizeHeader={renderGrandPrizeHeader}
            renderFooterText={renderFooterText}
            shopMoreUrl={shopMoreUrl}
          />
        </div>
      </div>
      <Dialog
        showDialog={visibility}
        fullWidth={platform !== 'website'}
        type="modal"
        onCancel={hideDialog}
        ariaLabel={GrandConstant.MODAL_HEADER}
      >
        <ModalContent
          modalHeader={GrandConstant.MODAL_HEADER}
          list={topShopperHowToWinList}
          rewardList={modalGoldData}
          linkText={GrandConstant.LINK.text}
          href={topShopperTermsHyperlink || GrandConstant.LINK.href}
          closeModal={hideDialog}
          platform={platform}
        />
      </Dialog>
    </div>
  );
}

GrandPrize.defaultProps = {};

export default connector(GrandPrize);
